module.exports = __webpack_public_path__ + "media/images/countrysquared/lb-d85349738b61de098b63dc67a7d7fbea.svg";